import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ModuleConsoleFooter } from "@/components/composition/ModuleConsoleFooter";
import { PageHeader } from "@/components/PageHeader";
import { t } from "@/core/composition/lexicon";
import {
  buildDepartmentSummaries,
  loadHospitalStaff,
} from "@/core/rh/rh-api";
import type { HospitalDepartmentSummary } from "@/core/rh/types";
import { routes } from "@/router/all_routes";

export function RhDepartmentsPage() {
  const [departments, setDepartments] = useState<HospitalDepartmentSummary[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const { staff } = await loadHospitalStaff();
      if (cancelled) return;
      setDepartments(buildDepartmentSummaries(staff));
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="ph-dashboard">
      <PageHeader
        title={t("rh.departments")}
        description="Services hospitaliers — croisement effectifs RH et unités médicales de l'établissement."
        actions={
          <Link to={routes.rhEmployees} className="btn btn-outline-secondary btn-sm">
            {t("rh.employees")}
          </Link>
        }
      />

      <div className="row g-3">
        {loading ? (
          <div className="col-12">
            <p className="text-muted small">Chargement…</p>
          </div>
        ) : (
          departments.map((dept) => (
            <div key={dept.id} className="col-12 col-md-6 col-xl-4">
              <div className="ph-dash-card h-100">
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <div>
                    <h3 className="h6 mb-1">{dept.name}</h3>
                    <span className="badge bg-light text-dark border">{dept.code}</span>
                  </div>
                  <span className="fs-4 fw-bold" style={{ color: "#0d9488" }}>
                    {dept.headcount}
                  </span>
                </div>
                <p className="small text-muted mb-0">
                  {dept.headcount === 1 ? "1 agent" : `${dept.headcount} agents`}
                  {dept.source === "establishment" && dept.headcount === 0
                    ? " · unité paramétrée (sans effectif RH)"
                    : ""}
                </p>
              </div>
            </div>
          ))
        )}
      </div>

      <ModuleConsoleFooter consoleRoute={routes.rhAdminConsole} moduleLabel="ITaaS RH" />
    </div>
  );
}
